function hideFields(element, value) {
  const div = $("#" + element).parents(".col-lg-6");
  const targetRewardField = div.find(".batch_file_target_reward");

  if (value == "relocate_rewards") {
    targetRewardField.show();
  } else {
    targetRewardField.hide();
  }
}

$(document).ready(function () {
  $(".batch_file_target_reward").hide();

  $(document).on("change", "select[id*=batch_file_batch_type]", function () {
    hideFields(this.id, this.value);
  });
});
